var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-24p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6898_184225",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6898_184225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "store",
    d: "M4.21157 5.74995V4.25H19.7885V5.74995H4.21157ZM4.25004 19.75V13.75H3.13464V12.25L4.21157 7.25H19.7885L20.8654 12.25V13.75H19.75V19.75H18.25V13.75H13.75V19.75H4.25004ZM5.74999 18.25H12.25V13.75H5.74999V18.25ZM4.66537 12.25H19.3347L18.5712 8.74995H5.42884L4.66537 12.25Z",
    fill: "#A5ACB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.7abac18b99aaf9444dda1be1e4b53d23.svg";
export { ForwardRef as ReactComponent };